import { constants } from "../../../constants";

export default class GameJackpotStart {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data){
        this.gb.emitters.emit.web.gameJackpotStart(data)
    }

    exposeEvent(){
        let event = {}

        switch (this.gb.gameProviderProtocol){
            case constants.OAK:
                event["bigwin_start"] = this._default;
                break;
            case constants.T4B:
                event["game.jackpot.started"] = this._default;
                break;
        }
        return event
    }

}